// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordedLesson_container__2gvfj","body":"RecordedLesson_body__QcSOT","header":"RecordedLesson_header__iDiUg","selector":"RecordedLesson_selector__1zU2j"};